import { isRouteErrorResponse } from 'react-router';

export const getErrorMessage = (error: unknown): string => {
  if (!error) return 'Неизвестная ошибка';

  // 1. Ошибки React Router (например, 404 через throw Response)
  if (isRouteErrorResponse(error)) {
    return (
      error.data?.message ||
      error.statusText ||
      `Ошибка роутинга: ${error.status}`
    );
  }

  // 2. Ошибки загрузки чанков (ChunkLoadError)
  if (
    error instanceof Error &&
    (error.name === 'ChunkLoadError' ||
      error.message?.includes('Loading chunk'))
  ) {
    return 'Ошибка сети. Не удалось загрузить часть приложения.';
  }

  // 3. Стандартные JS ошибки или объекты с полем message
  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === 'object' && error !== null && 'message' in error) {
    const message = (error as { message: unknown }).message;
    if (typeof message === 'string') return message;
  }

  // 4. Ошибки RTK Query (FetchBaseQueryError)
  if (typeof error === 'object' && error !== null && 'status' in error) {
    const fetchError = error as {
      status: unknown;
      data?: { message?: string };
    };
    return fetchError.data?.message || `Ошибка сервера: ${fetchError.status}`;
  }

  // 5. Если пришла просто строка
  if (typeof error === 'string') return error;

  return 'Произошла непредвиденная ошибка';
};
